import { render, staticRenderFns } from "./MyCoursesColorPicker.vue?vue&type=template&id=2258a472&"
import script from "./MyCoursesColorPicker.vue?vue&type=script&lang=js&"
export * from "./MyCoursesColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesColorPicker.vue?vue&type=style&index=0&id=2258a472&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports